import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { AdSlot, DFPManager } from 'react-dfp';

import ContentWrapper from 'shared/components/layout/ContentWrapper';
import WithWindowSize from 'shared/components/WithWindowSize';

import adUnits from './adUnits';

const placements = {
  panorama: 'panorama',
  insider: 'insider',
};

const Ad = ({ placement, windowWidth }) => {
  const { name, sizes, sizeMapping } = adUnits[placement];

  const [id, setId] = useState();
  const lastWindowWidth = useRef(windowWidth);

  // Refresh ad when window is resized
  useEffect(() => {
    if (
      id != null &&
      sizeMapping != null &&
      windowWidth !== lastWindowWidth.current
    ) {
      DFPManager.refresh(id);
      lastWindowWidth.current = windowWidth;
    }
  }, [windowWidth, id, sizeMapping]);

  const onSlotRender = useCallback(e => {
    setId(e.slotId);
  }, []);

  const slot =
    process.env.REACT_APP_ADS_ENABLED === 'true' ? (
      <AdSlot
        adUnit={name}
        onSlotRender={onSlotRender}
        sizes={sizes}
        sizeMapping={sizeMapping}
        className="ad__slot"
      />
    ) : (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: `${sizes[sizes.length - 1][0]}px`,
          height: `${sizes[sizes.length - 1][1]}px`,
          maxWidth: '100%',
          opacity: '0.4',
          background: '#bdbdbd',
          fontSize: '12px',
          color: '#555',
          textAlign: 'center',
        }}
      >
        {placement}
        <br />
        {sizes[sizes.length - 1].join('x')}
      </div>
    );

  return (
    <div className={`ad ad--${placement}`}>
      <ContentWrapper className="ad__content-wrapper">
        <div>
          <p className="ad__label">Annons</p>
          {slot}
        </div>
      </ContentWrapper>
    </div>
  );
};

Ad.propTypes = {
  placement: PropTypes.oneOf(Object.keys(placements)).isRequired,
};

export default WithWindowSize()(Ad);
